import { useState } from 'react';
import { Checkbox } from '@shared/uikit/checkbox';
import { TextSize, Typography } from '@shared/index';
import { LineGraph } from './hashrate-dynamics-line-graph';
import { monthNamesRu, getQuarterByMonthIndex } from '@app/utils/quarters';
import { format } from 'date-fns';
import { groupByMonths, groupByQuarters } from './groupHashrateData';
import { useGetManagerHashrateLine } from '@entities/managers-perfomance';

type Props = {
  managerId?: number | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  onByMonthsChange?: (value: boolean) => void;
  onByQuartersChange?: (value: boolean) => void;
  defaultByMonths?: boolean;
  defaultByQuarters?: boolean;
};

export const HashrateDynamics = ({
  onByMonthsChange,
  onByQuartersChange,
  defaultByMonths = true,
  defaultByQuarters = false,
  managerId = null,
  dateFrom,
  dateTo,
}: Props) => {
  const [byMonths, setByMonths] = useState<boolean>(defaultByMonths);
  const [byQuarters, setByQuarters] = useState<boolean>(defaultByQuarters);

  const currentYear = new Date().getFullYear();
  const fallbackDateFrom = format(new Date(currentYear, 0, 1), 'yyyy-MM-dd');
  const fallbackDateTo = format(new Date(), 'yyyy-MM-dd');

  const effectiveDateFrom = managerId ? null : (dateFrom ?? fallbackDateFrom);
  const effectiveDateTo = managerId ? null : (dateTo ?? fallbackDateTo);

  const { data: hashrateLine } = useGetManagerHashrateLine(
    managerId,
    effectiveDateFrom,
    effectiveDateTo
  );

  const handleByMonthsChange = (value: boolean) => {
    setByMonths(value);
    onByMonthsChange?.(value);
  };

  const handleByQuartersChange = (value: boolean) => {
    setByQuarters(value);
    onByQuartersChange?.(value);
  };

  const monthData = hashrateLine && byMonths ? groupByMonths(hashrateLine) : [];
  const quarterData = hashrateLine && byQuarters ? groupByQuarters(hashrateLine) : [];

  const chartData = monthNamesRu.map((name, monthIndex) => {
    const monthValue = monthData.find(m => m.name === name)?.value || 0;
    const quarterIndex = getQuarterByMonthIndex(monthIndex) - 1;
    const quarterValue = quarterData[quarterIndex]?.value || 0;

    return {
      name,
      monthValue,
      quarterValue,
    };
  });

  return (
    <>
      <div className="flex justify-between items-center mb-[20px] p-4">
        <Typography title="Динамика хешрейта" size={TextSize.size24} className="font-bold" />
        <div className="flex flex-wrap gap-x-[14px]">
          <Checkbox
            value={byMonths}
            onChange={handleByMonthsChange}
            label="По месяцам"
            labelClassName="text-base font-medium"
          />
          <Checkbox
            value={byQuarters}
            onChange={handleByQuartersChange}
            label="По кварталам"
            labelClassName="text-base font-medium"
          />
        </div>
      </div>
      <LineGraph data={chartData} showMonths={byMonths} showQuarters={byQuarters} />
    </>
  );
};
